import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';


import { ProjectRelatedVersionsRequests } from '@core/store/state/project-related-versions/project-related-versions.requests';

import * as fromState from '@core/store/state/project-related-versions/project-related-versions.state';
import * as fromActions from '@core/store/state/project-related-versions/project-related-versions.actions';


@Injectable()
export class ProjectRelatedVersionsEffects {

    protected readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';

    constructor(private actions$: Actions, private store$: Store<fromState.ProjectRelatedVersions>,
        private requests: ProjectRelatedVersionsRequests) { }


  
    public setProject$ = createEffect(() => this.actions$.pipe(
        ofType(fromActions.SetProject),
        map((action) => {
            return fromActions.LoadRelated({ project: action.project });
        })
    ));

    public loadProjectRelatedVersions$ = createEffect(() => this.actions$.pipe(
        ofType(fromActions.LoadRelated),
        mergeMap((action) => {
            return this.requests.loadRelated$(action.project.id ).pipe(
                map((versions: Array<Objects.Version>) => {
                    return fromActions.LoadRelatedSuccess({ versions });
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(fromActions.LoadRelatedError(err));
                })
            );
        })
    ));

    public loadRelatedSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(fromActions.LoadRelatedSuccess),
        withLatestFrom(this.store$.select(fromState.projectRelatedVersionsFeedbacksAccessSelector)),
        switchMap(([action, feedbackAccess]) => {
            let effectEvents = [];
            // add effect to load feedbacks for all related loaded
            if (feedbackAccess && action.versions != null && action.versions.length > 0) {
                effectEvents.push(fromActions.LoadFeedbacks({ versions: action.versions }));
            }
            return effectEvents;
        })
    ));

    public loadVersionsFeedbacks$ = createEffect(() => this.actions$.pipe(
        ofType(fromActions.LoadFeedbacks),
        switchMap((action) => {
            
            return this.requests.getRelatedShareItems$(action.versions).pipe(
                map((feedbacks: VersionShareItem[]) => {
                    return fromActions.LoadFeedbacksSuccess({feedbacks});
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(fromActions.LoadFeedbacksError(err));
                })
            );
        }
        )
    ));

}